/**
 * -----------------------------------------------------------------------------
 * It renders the ImagePreviewSquareIcon icon
 */
export function ImagePreviewSquareIcon() {
  return (
    <svg
      className="size-8"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path d="M11.677 7.321a.25.25 0 1 1-.355.353.25.25 0 0 1 .355-.353m9.327 1.208a7.431 7.431 0 0 0-8.474 8.473" />

      <path d="M6.998 6.998h-1a3.001 3.001 0 0 0-3.002 3.001v8.004a3.001 3.001 0 0 0 3.001 3h8.004a3.001 3.001 0 0 0 3.001-3v-1" />

      <path d="M18.003 2.996H9.999a3.001 3.001 0 0 0-3.001 3.001v8.004a3.001 3.001 0 0 0 3.001 3.001h8.004a3.001 3.001 0 0 0 3-3.001V5.998a3.001 3.001 0 0 0-3-3.002Z" />
    </svg>
  );
}
